module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Julia is originally from New Zealand and grew up in the land of the long white cloud. She moved to Australia in her late teens where she currently resides. She has family all around the world including but not limited to Tasmania, England, USA with her immediate family remaining in New Zealand. Julia has been writing for over fifteen years and she has continued to branch out, broadening her horizons by not only writing novels, but also dabbling in scripts and short stories, among other literary works. "), _c('em', [_vm._v("Pathway to Devastation Trilogy")]), _vm._v(" is her first published achievement which she is very proud of and hopes her readers will enjoy it as much as she did.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0